import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { StatusPage } from '@/components/marketing/StatusPage';

export const Route = createFileRoute('/_public/status')({
  component: () => (
    <MarketingShell currentPath="/status">
      <StatusPage />
    </MarketingShell>
  ),
});
